var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('loader-state'):(_vm.isError)?_c('error-card',{attrs:{"suggest-refresh":""}}):(_vm.survey)?_c('survey-vue',{attrs:{"survey":_vm.survey}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }